import React from 'react';
import './SkeletonCard.module.scss';

export default function SkeletonCard() {
    return (
        <div styleName="skeleton-card">
            <div styleName="image" />
            <div styleName="heading" />
            <div styleName="paragraph" />
            <div styleName="paragraph" />
            <div styleName="paragraph" />
            <div styleName="paragraph" />
        </div>
    );
}
